import { render } from "./Ticker.vue?vue&type=template&id=5a68648a&scoped=true&ts=true"
import script from "./Ticker.vue?vue&type=script&lang=ts"
export * from "./Ticker.vue?vue&type=script&lang=ts"

import "./Ticker.vue?vue&type=style&index=0&id=5a68648a&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a68648a"]])

export default __exports__